import styled from 'styled-components';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
`;

/* product header; takes an image as a child */
export const ProductHeaderImg = styled.img`
  display: block;
  max-width: 340px;
  flex: 0 0 34px;
  margin: 0 auto 10px auto;
`;

/* agreement text */
export const AgreementTextBox = styled.div`
  width: 100%;
  flex: 1 1 320px;
  background-color: white;
  border: 2px solid teal;
  overflow-y: auto;
`;

/* child container for the actual text to give padding to the node prop */
export const AgreementTextContainer = styled.div`
  display: flex;
  justify-content: center;
`;

/* must scroll to bottom text */
export const ScrollToBottomText = styled.div`
  width: 100%;
  color: #590c0c;
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;

/* understanding text container */
export const UnderstandContainer = styled.div`
  width: 100%;
  max-width: 900px;
  cursor: pointer;
  margin: 0 auto 10px auto;
  display: flex;
  justify-content: center;
`;

interface UnderstandTextProps {
  color?: string;
}

/* the text label for the understand checkbox */
export const UnderstandText = styled.div<UnderstandTextProps>`
  cursor: pointer;
  color: ${(props) => props.color};
  display: inline;
  font-size: 14px;
`;

export const WarningText = styled.span`
  color: #590c0c;
`;
